import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=147ccb8a&scoped=true&"
import script from "./SideNavigation.vue?vue&type=script&lang=js&"
export * from "./SideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=147ccb8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ccb8a",
  null
  
)

export default component.exports